module.exports = __webpack_public_path__ + "static/img/26.cfacd3c0.png";